export const API_BASE_URL = "https://us-central1-invoice-engine-52a3a.cloudfunctions.net/api/api";

export const CLIENTS = [
  { code: "AESL", name: "Allied Engineering", ntn: "2559954-2" },
  { code: "ARSL", name: "Allied Rental Services Limited", ntn: "2559954-2" },
  { code: "ATL", name: "Allied Transport Limited", ntn: "A102941" },
  { code: "ATL_COCACOLA", name: "ATL CocaCola (Allied Transport Limited)", ntn: "A102941" },
  { code: "ES", name: "E-Commerce", ntn: "2559954-2" },
  {
    code: "CORTEVA",
    name: "Corteva Agriscience Pakistan Limited",
    address: "Office # 1-A, 8th Floor Business HUB CBW Phase VIII DHA Lahore",
    ntn: "0453322-4",
    gstNo: "03-90-9999-536-55"
  },
  { code: "TEMP", name: "Other / Temporary Client", ntn: "" }
];
